import React from "react";
import { Link, useLocation } from "react-router-dom";
import { clients, dashboard, offers, others } from "./adminRoutes";

const SideBar = () => {
  const { pathname } = useLocation();

  const showSideBarLinks = (routes) => {
    return routes.map((el, key) => (
      <li
        className={` ${pathname === el.link ? "active nav-irisk-active" : ""}`}
        key={key}
      >
        <Link
          to={el.link}
          className={`waves-effect ${pathname === el.link ? "active " : ""}`}
          style={
            el.name === "PlaceIT"
              ? { backgroundColor: "#ffdddd", color: "#4d79f6" }
              : {}
          }
        >
          <i
            className={el.icon}
            style={el.name === "PlaceIT" ? { color: "#4d79f6" } : {}}
          ></i>
          <span style={el.name === "PlaceIT" ? { color: "#4d79f6" } : {}}>
            {el.name}
          </span>
          {el.isNew && (
            <span
              className="badge badge-pill badge-primary float-right"
              style={{
                position: "absolute",
                right: "15px",
                fontSize: "10px",
                padding: "3px 8px",
                backgroundColor: "#4d79f6",
                color: "white",
              }}
            >
              NEW
            </span>
          )}
        </Link>
      </li>
    ));
  };

  return (
    <div className="vertical-menu nav-irisk-sidebar">
      <div data-simplebar className="h-100">
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            {showSideBarLinks(dashboard)}
            <li className="menu-title">Offers</li>
            {showSideBarLinks(offers)}
            <li className="menu-title">Clients</li>
            {showSideBarLinks(clients)}
            <li className="menu-title">Others</li>
            {showSideBarLinks(others)}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SideBar;
